import * as types from "../ActionType";

const initState = {
    scriptsArchive: [],
    loadingScriptsArchive: true,
    oneScriptsArchive: {},
    loadingOneScriptsArchive: true,
    page_list_scripts_archive: {},
    loadingPageListScriptsArchive: true,
}

const ScriptArchiveReducer = (state = initState, action) => {
    switch (action.type) {
        case types.ADD_SCRIPT_ARCHIVE:
            return { ...state, loadingScriptsArchive: true }
        case types.PAGE_LIST_SCRIPT_ARCHIVE:
            return { ...state, page_list_scripts_archive: action.payload, loadingPageListScriptsArchive: false }
        case types.GET_SCRIPTS_ARCHIVE:
            return { ...state, scriptsArchive: action.payload, loadingScriptsArchive: false }
        case types.ONE_SCRIPT_ARCHIVE:
            return { ...state, oneScriptsArchive: action.payload, loadingOneScriptsArchive: false }
        case types.EMPTY_SCRIPT_ARCHIVE:
            return { ...state, oneScriptsArchive: action.payload, loadingOneScriptsArchive: true }
        case types.DELETE_SCRIPT_ARCHIVE:
            return { ...state }
        /*case types.DELETE_PROJECT:
            return { ...state}
        case types.EDIT_PROJECT:
            return { ...state, loadingProjects: true }*/
        default:
            return state;
    }
};

export default ScriptArchiveReducer;
